import { render, staticRenderFns } from "./Contactos.vue?vue&type=template&id=68ae9278&"
import script from "./Contactos.vue?vue&type=script&lang=js&"
export * from "./Contactos.vue?vue&type=script&lang=js&"
import style0 from "./Contactos.vue?vue&type=style&index=0&id=68ae9278&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports